// Shared leaderboard data used across ForBrokers, ForTenants, ForLandlords
export const CITY_AGENTS = {
  Bangalore: [
    { rank: 1, name: "Deepa Krishnan", area: "Koramangala",  rating: 4.9, deals: 41, tenants: 38, disputes: 0 },
    { rank: 2, name: "Rahul Shetty",   area: "Indiranagar",  rating: 4.8, deals: 36, tenants: 33, disputes: 1 },
    { rank: 3, name: "Meera Iyer",     area: "Whitefield",   rating: 4.7, deals: 29, tenants: 27, disputes: 0 },
    { rank: 4, name: "Karthik Reddy",  area: "HSR Layout",   rating: 4.7, deals: 27, tenants: 25, disputes: 0 },
    { rank: 5, name: "Anita Nair",     area: "Marathahalli", rating: 4.6, deals: 24, tenants: 22, disputes: 1 },
  ],
  Mumbai: [
    { rank: 1, name: "Imran Khan",    area: "Andheri West", rating: 4.9, deals: 47, tenants: 44, disputes: 0 },
    { rank: 2, name: "Priya Sharma",  area: "Bandra",       rating: 4.8, deals: 39, tenants: 36, disputes: 0 },
    { rank: 3, name: "Ravi Nair",     area: "Powai",        rating: 4.8, deals: 35, tenants: 31, disputes: 1 },
    { rank: 4, name: "Sunita Joshi",  area: "Thane",        rating: 4.7, deals: 31, tenants: 28, disputes: 0 },
    { rank: 5, name: "Arjun Mehta",   area: "Borivali",     rating: 4.7, deals: 28, tenants: 26, disputes: 0 },
  ],
  Pune: [
    { rank: 1, name: "Vikram Desai",    area: "Kothrud",     rating: 4.9, deals: 33, tenants: 30, disputes: 0 },
    { rank: 2, name: "Sneha Kulkarni",  area: "Wakad",       rating: 4.8, deals: 28, tenants: 26, disputes: 0 },
    { rank: 3, name: "Amit Joshi",      area: "Hinjewadi",   rating: 4.7, deals: 25, tenants: 23, disputes: 1 },
    { rank: 4, name: "Pooja Patil",     area: "Baner",       rating: 4.7, deals: 22, tenants: 20, disputes: 0 },
    { rank: 5, name: "Rohit Deshpande", area: "Viman Nagar", rating: 4.6, deals: 19, tenants: 17, disputes: 0 },
  ],
  Delhi: [
    { rank: 1, name: "Manish Gupta",  area: "Dwarka",       rating: 4.9, deals: 38, tenants: 35, disputes: 0 },
    { rank: 2, name: "Neha Singh",    area: "Lajpat Nagar", rating: 4.8, deals: 31, tenants: 28, disputes: 0 },
    { rank: 3, name: "Rajesh Kumar",  area: "Rohini",       rating: 4.7, deals: 26, tenants: 23, disputes: 1 },
    { rank: 4, name: "Anjali Sharma", area: "Saket",        rating: 4.7, deals: 23, tenants: 21, disputes: 0 },
    { rank: 5, name: "Vikash Yadav",  area: "Noida",        rating: 4.6, deals: 21, tenants: 19, disputes: 0 },
  ],
  Hyderabad: [
    { rank: 1, name: "Srinivas Rao",  area: "Jubilee Hills", rating: 4.9, deals: 35, tenants: 32, disputes: 0 },
    { rank: 2, name: "Lakshmi Devi",  area: "Banjara Hills", rating: 4.8, deals: 29, tenants: 27, disputes: 0 },
    { rank: 3, name: "Arun Kumar",    area: "Madhapur",      rating: 4.7, deals: 24, tenants: 22, disputes: 0 },
    { rank: 4, name: "Preethi Reddy", area: "Gachibowli",    rating: 4.7, deals: 21, tenants: 19, disputes: 1 },
    { rank: 5, name: "Suresh Babu",   area: "Kondapur",      rating: 4.6, deals: 18, tenants: 16, disputes: 0 },
  ],
  Chennai: [
    { rank: 1, name: "Karthik Suresh", area: "Adyar",         rating: 4.9, deals: 31, tenants: 28, disputes: 0 },
    { rank: 2, name: "Divya Menon",    area: "Anna Nagar",    rating: 4.8, deals: 26, tenants: 24, disputes: 0 },
    { rank: 3, name: "Ramesh Babu",    area: "Velachery",     rating: 4.7, deals: 22, tenants: 20, disputes: 0 },
    { rank: 4, name: "Shalini Kumar",  area: "Nungambakkam",  rating: 4.7, deals: 19, tenants: 17, disputes: 1 },
    { rank: 5, name: "Vijay Anand",    area: "T Nagar",       rating: 4.6, deals: 17, tenants: 15, disputes: 0 },
  ],
};

export const CITIES = Object.keys(CITY_AGENTS);

export function initials(name) {
  return name.split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase();
}
